export default __webpack_public_path__ + "static/media/vp1.271392b2.jpg";